import {
	AngleDown, AngleUp, Checkbox, cn, Counter, Label, Menu,
} from '@aleph/shared-components';
import { SelectComponentsConfig, components } from 'react-select';

// TODO: should be exported from @aleph/shared-components
export const AsyncSelectComponents: SelectComponentsConfig<any, any, any> = {
	IndicatorSeparator: null,
	ClearIndicator:     () => null,
	SelectContainer:    ({ children, ...props }) => (
		<components.SelectContainer
			{...props}
			className={cn(props.className, 'flex-1 !w-full !h-full leading-none')}
		>
			{children}
		</components.SelectContainer>
	),
	Control: ({ children, ...props }) => (
		<components.Control
			{...props}
			className={cn(props.className, '!border-0 !shadow-none px-[8px] !min-h-full')}
		>
			{children}
		</components.Control>
	),
	ValueContainer: ({ children, ...props }) => (
		<components.ValueContainer
			{...props}
			className={cn(props.className, '!p-0 !flex-nowrap !overflow-hidden justify-between')}
		>
			{
				props.isMulti && props.hasValue
					? <div className="overflow-hidden overflow-ellipsis flex items-center">{children}</div>
					: children
			}
			{
				props.isMulti
				&& <div className="flex items-center justify-center mr-[8px]">
					<Counter
						count={props.getValue()?.length}
						color="subtle"
						className="relative"
					/>
				</div>
			}
		</components.ValueContainer>
	),
	SingleValue: ({ children, ...props }) => (
		<components.SingleValue
			{...props}
			className={cn(props.className, 'text-[14px] !m-0')}
		>
			<div className="flex items-center gap-[8px]">
				{props?.data?.icon && <div className="min-w-[16px]">{props?.data?.icon}</div>}
				<div className="overflow-hidden overflow-ellipsis">{children}</div>
			</div>
		</components.SingleValue>
	),
	MultiValue: ({ children, ...props }) => (
		<span>{props.index > 0 && ', '}{props.data?.label}</span>
	),
	Input: ({ children, ...props }) => (
		<components.Input
			{...props}
			// TODO: take another look at this as it breaks &
			//  puts user in an infinite loop when multiple selects are rendered
			innerRef={(ref) => setTimeout(() => ref?.focus(), 0)}
			className={
				cn(
					props.className,
					'!p-0 !text-[13px] font-semibold',
					{
						'!ml-[4px]': props.hasValue,
					},
				)
			}
		>
			{children}
		</components.Input>
	),
	Placeholder: ({ children, ...props }) => (
		<components.Placeholder
			{...props}
			className={cn(props.className, '!m-0 !p-0')}
		>
			{children}
		</components.Placeholder>
	),
	DropdownIndicator: ({ ...props }) => (
		<components.DropdownIndicator
			{...props}
			className={cn(props.className, '!text-black cursor-pointer !p-0')}
		>
			{
				props.selectProps?.menuIsOpen ? <AngleUp
					width={16}
					height={16}
				/> : <AngleDown
					width={16}
					height={16}
				/>
			}

		</components.DropdownIndicator>
	),
	Menu: ({ children, ...props }) => (
		<components.Menu
			{...props}
			// to be border to border of neighbouring cells we need ml-[-1px] & width calc
			className={
				cn(
					props.className,
					'p-[4px] !my-[2px] ml-[-1px] w-[calc(100%+2px)] !shadow-[0px_1px_3px_0px_rgba(0,0,0,0.25)]',
				)}
		>
			{children}
		</components.Menu>
	),
	MenuList: ({ children, ...props }) => (
		<components.MenuList
			{...props}
			className={cn(props.className, '!p-0')}
			data-testid="menu-list"
		>
			{children}
		</components.MenuList>
	),
	Option: ({ children, ...props }) => (
		<components.Option
			{...props}
			className="!p-0 !h-fit-content !rounded-[2px] !bg-transparent"
		>
			<Menu.Item
				selected={props.isSelected}
				isFocused={props.isFocused}
			>
				{props.selectProps?.isMulti
					&& <Checkbox
						className="pointer-events-none"
						checked={props.isSelected}
					/>
				}
				<Label>
					{props.selectProps?.isMulti
						? <div className="whitespace-nowrap">{children}</div>
						: <div className="flex items-center gap-[8px]">
							{props?.data?.icon}
							<div className="whitespace-nowrap">{children}</div>
						</div>
					}
				</Label>
			</Menu.Item>
		</components.Option>
	),
};
